import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

export default function Authors() {
  const [authors, setAuthors] = useState([]);
  useEffect(() => { api.get("/authors").then((r) => setAuthors(r.data || [])).catch(() => {}); }, []);
  return (
    <div className="max-w-[1000px] mx-auto px-4 sm:px-6 py-10">
      <div className="border-b-2 border-ink pb-3 mb-8">
        <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-crimson">The Fin Desk</div>
        <h1 className="font-serif font-bold text-4xl sm:text-5xl text-ink mt-1">Authors</h1>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        {authors.map((a) => (
          <Link key={a.id} to={`/authors/${a.slug}`} className="border border-hair p-6 hover:border-crimson transition-colors group bg-surface">
            <h2 className="font-serif text-2xl text-ink group-hover:text-crimson">{a.name}</h2>
            <div className="text-xs uppercase tracking-widest text-crimson font-bold mt-1">{a.role}</div>
            <p className="text-sm text-ink2 mt-3 line-clamp-3">{a.bio}</p>
            <div className="text-xs text-mutedink mt-3 font-mono">{a.article_count} articles</div>
          </Link>
        ))}
      </div>
    </div>
  );
}
